import { useToursLazyQuery } from '@kinetic-ui/data-layer';
import { DataSource, FormOption } from '@qfa/forms';
import { getNodes } from 'kineticUtils';
import { useCallback, useMemo } from 'react';

export const useVideoToursDataSource = (): DataSource<FormOption[]> => {
  const [loadTours] = useToursLazyQuery();
  const load = useCallback(async () => {
    const { data } = await loadTours();
    const tours = getNodes(data?.tours);

    return tours.map((tour) => {
      return {
        label: tour.name,
        value: tour.id,
      };
    });
  }, [loadTours]);

  return useMemo(() => {
    return {
      load: load,
    };
  }, [load]);
};
